import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/component_model`;


export const saveComponentModelSection = async (componentModelSectionData) => {

    try {
        const response = await api.post(API_URL, componentModelSectionData);
        return response.data;
    } catch (error) {
handleHttpError(error, "Échec de l'enregistrement du composant Model Section");
        
        console.error('Error fetching componentModelSection:', error);
        throw error;

    }
};
export const getComponentModelSectionById = async (idComponentModelSection) => {
    const url = `${API_URL}/${idComponentModelSection}`;

    try {
        const response = await api.get(url);
        return response.data;

    } catch (error) {
        handleHttpError(error, "Erreur lors de la récupération du composant Model Section");
        
        console.error('Error fetching componentModelSection:', error);
        throw error;

    }
};



  

export const updateComponentModelSection = async (idComponentModelSection,componentModelSectionData) => {
    const url = `${API_URL}/${idComponentModelSection}`;

    try {
        const response = await api.put(url, componentModelSectionData);
        return response.data;

    } catch (error) {
handleHttpError(error, "Échec de la modification du composant Model Section");
        throw error;

    }
};

export const getAllComponentModelSections = async () => {
    try {
        const response = await api.get(API_URL);
        return response.data;
    } catch (error) {
        handleHttpError(error, "Échec lors de la récupération de la liste des composants Model Section");

        console.error('Error fetching componentModelSection:', error);

    }
}

export const allSectionComponentModelSections = async(sectionDataId)=> {
    const url = `${API_URL}/section/${sectionDataId}`;

      try {
          const response = await api.get(url);

          return response.data;
          } catch (error) {
                    handleHttpError(error, "Échec lors de la récupération de la liste des composants Model Section");

          console.error('Error fetching section Content:', error);
          return [];
          }
  }

  export const allSectionComponentModelSectionsByPosition = async(idPosition)=> {
    const url = `${API_URL}/position_section/${idPosition}`;
      try {
          const response = await api.get(url);
          return response.data;
          } catch (error) {
           handleHttpError(error, "Échec lors de la récupération de la  composants Model Section par is de la position");

          console.error('Error fetching section Content:', error);
          return [];
          }
  }


  export const deleteComponentModelSection = async (idComponentModelSection) => {

    const url = `${API_URL}/${idComponentModelSection}`;

    try {
       await api.delete(url);

    } catch (error) {
        handleHttpError(error, "Échec lors de la Suppression de la  composants Model Section par is de la position");

        console.error('Error fetching componentModelSection:', error);
        throw error;

    }
};